import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homepage-two',
  templateUrl: './homepage-two.component.html',
  styleUrls: ['./homepage-two.component.scss']
})
export class HomepageTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
